import React, {Component} from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import {Toolbar, Data} from 'react-data-grid-addons';
import {UI_HEIGHT} from '../Common/constants';
import {Grid, Row, Col, Panel, Button, ButtonGroup, Table, ButtonToolbar} from 'react-bootstrap';
import {Link} from 'react-router';
import {Line, Doughnut} from 'react-chartjs';
import Time from '../Common/time';
import Selection from '../Common/selection';
import Spinner from '../Widgets/spinner';
import PurchaseQuoteModal from '../../containers/Purchase/purchaseQuoteModal';
import NewFavoriteModal from '../../containers/Favorites/favoriteModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import InputField from '../Common/inputField';
import { Field, FieldArray } from 'redux-form';
import { Translate, Localize } from 'react-redux-i18n';

class ZoneInformation extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

            createReturnOpen: false,
            createQuoteOpen: false,
            createFavoriteOpen: false,
            availableBins: 0,
            totalBins: 0,

            zones: {
                rows: [],
                allRows: [],
                sortColumn: null,
                sortDirection: null,
            },
        };

        this.handleResize = this.handleResize.bind(this);

    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchWarehouses();
        this.props.fetchWarehouseBins(1);
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {

        if (nextProps.warehouseChosen && nextProps.warehouseChosen != this.props.warehouseChosen) {
          this.props.fetchWarehouseBins(nextProps.warehouseChosen.value);
        }

        if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail != this.props.warehouseBinsDetail) {
            let totalAvailable = 0;
            let totalWarehouseBins = 0;
            nextProps.warehouseBinsDetail.Warehouse_Zone.map(zone => {
                totalAvailable += zone.AvailableBin;
                totalWarehouseBins += zone.TotalBin;
            });

            let zones = {...this.state.zones, rows: nextProps.warehouseBinsDetail.Warehouse_Zone}
            this.setState({zones, availableBins: totalAvailable, totalBins: totalWarehouseBins});
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton});
    }


    renderZonesTable() {
      if (this.props.SOIsLoading && !this.props.SOError) return <Spinner/>
      else if (this.props.SOError) return <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.SOError)}</div>
      </ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.zones);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var zones = {...this.state.zones, sortColumn, sortDirection};
              this.setState({zones});
          }

          // Handle the row select function

          const onRowSelect = rows => {
              var zones = {...this.state.zones, selectedRows: rows};
              this.setState({zones});
          }

          //Custom Formatter component

          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNameFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.Name}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNumFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
              {
                  key: 'Name',
                  name: <Translate value="zone_name" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'AvailableBin',
                  name: <Translate value="bins_available" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'TotalBin',
                  name: <Translate value="total_bins" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              }
          ]

          return (
              <Row><Col sm={ 12 }>
                  <div style={{maxWidth: '99%'}} id="ZoneInformation-dataGrid1">
                      <ReactDataGrid
                          rowKey='WarehouseZone_id'
                          onGridSort={handleGridSort}
                          columns={columns}
                          rowGetter={rowGetter}
                          rowsCount={getSize() }
                          minHeight={this.state.tableHeight/2}
                          rowHeight={32}
                          enableRowSelect='single'
                          onRowSelect={onRowSelect}/>
                  </div>
              </Col></Row>
          )
      }
    }

    getWarehouseOptions() {
       var warehouseOptions = [];
       this.props.warehouses.map(warehouse => {
          warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
       })
       return warehouseOptions;
    }


    selectZone(e) {
      e.preventDefault();
      this.props.fetchBinListFromZone( this.state.zones.selectedRows[0].WarehouseZone_id, this.props.currentWarehouseReceive);
    }

    render() {
        const { handleSubmit, numPurchaseQuotes } = this.props;

        var warehouseOptions = this.getWarehouseOptions();

        var data = [
            {color: "#97ddf0", label: "test1", value: 2},
            {color: "#fafafa", label: "test2", value: 1}
        ];

        var options = {
            animateRotate: true
        }

        let createDialogStyle = {
            width: '600px',
            marginLeft: '-10%',
        };

        var panelHeader = (
          <Row>
            <Col xs={12}><h3><Translate value="warehouse_bins" /></h3></Col>
          </Row>
        );

        return (
            <ContentWrapper>
                <Row>
                    <Col sm={ 12 }>
                        <Row>
                          <Col xs={12}>
                            <Field name="Warehouse" component={Selection} options={warehouseOptions} />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} className="text-center">
                            <Panel header={panelHeader} >
                              <span>{this.state.availableBins}<Translate value="available" /> / {this.state.totalBins} <Translate value="total_bins" /></span>
                            </Panel>
                            <Panel>
                              {this.renderZonesTable()}
                            </Panel>
                          </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <button className="btn btn-primary col-sm-11 buttonStyle" onClick={(e) => this.selectZone(e)} ><Translate value="select_zone" /></button>
                </Row>
            </ContentWrapper>
        );
    }
}


export default ZoneInformation;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/zoneInformation.jsx